import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import './Banner.css';

const Banner = () => {
  return (
    <div className="banner-container">
      <Splide
        options={{
          type: "fade",
          perPage: 1,
          pagination: true,
          arrows: true,
          autoplay: true,
          interval: 3000,
          speed: 800,
          rewind: true,
        }}
        className="splide-banner"
      >
        <SplideSlide>
          <div className="slide-content">
            <video src="/img/WhatsApp Video 2025-09-15 at 1.11.35 AM.mp4" autoPlay loop muted playsInline className="banner-img" />
            <div className="overlay">
              <h1 className="highlight">Precision Engineering Solutions</h1>
              <p>
                Empowering industries with advanced engineering tools and
                consumables that deliver consistent quality and long-lasting
                performance in every application.
              </p>
              <div className="buttons">
                <a href="/industries" className="btn btn-primary">Industries</a>
                <a href="/products" className="btn btn-secondary">Products</a>
              </div>
            </div>
          </div>
        </SplideSlide>

        <SplideSlide>
          <div className="slide-content">
            <video src="/img/WhatsApp Video 2025-09-15 at 1.11.35 AM.mp4" autoPlay loop muted playsInline className="banner-img" />
            <div className="overlay">
              <h1 className="highlight">Reliable Tools for Every Sector</h1>
              <p>
                From manufacturing to maintenance, our complete range of
                industrial tools ensures efficiency, safety, and durability for
                businesses of every size.
              </p>
              <div className="buttons">
                <a href="/industries" className="btn btn-primary">Industries</a>
                <a href="/products" className="btn btn-secondary">Products</a>
              </div>
            </div>
          </div>
        </SplideSlide>

        <SplideSlide>
          <div className="slide-content">
            <video src="/img/WhatsApp Video 2025-09-15 at 1.11.35 AM.mp4" autoPlay loop muted playsInline className="banner-img" />
            <div className="overlay">
              <h1 className="highlight">Complete Industrial Consumables</h1>
              <p>
                Delivering top-grade consumables and equipment that help
                professionals achieve productivity, precision, and superior
                results across demanding operations.
              </p>
              <div className="buttons">
                <a href="/industries" className="btn btn-primary">Industries</a>
                <a href="/products" className="btn btn-secondary">Products</a>
              </div>
            </div>
          </div>
        </SplideSlide>

      </Splide>
    </div>
  );
};

export default Banner;
